module.exports = __webpack_public_path__ + "img/RikReppe.910dc57b.jpg";